<button style="float:right;" class="btn btn-primary " type="button" mdbBtn  rounded="true" data-toggle="modal" data-target="#basicExample"
        (click)="frame.show()" mdbWavesEffect>{{ 'texto_60' | translate }}
</button>

<div mdbModal #frame="mdbModal" class="modal fade top" id="frameModalTop" tabindex="-1" role="dialog"
     aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog cascading-modal modal-avatar modal-sm" role="document">
    <!--Content-->
    <div class="modal-content" >

        <div class="modal-body mx-3" style="padding-right: 1rem; padding-left: 1rem;">
            <div class="card-header card-header-info">
              <h5 style="margin-bottom: 0px;" class="card-title">{{ 'texto_102' | translate }}</h5>
          </div>
          <button type="button" style="z-index:100;float: right;margin-top: -2.8rem;" class="btn btn-dark" data-dismiss="modal" (click) = "frame.hide()"aria-label="Cerrar modal">X</button> 

            <div class="md-form mb-3 mt-5">
              <input type="text" id="form-user" class="form-control" [formControl]="signupFormModalId" mdbInput mdbValidate>
              <label for="form-user">{{ 'texto_91' | translate }}</label>
              <mdb-error
                *ngIf="signupFormModalId.invalid && (signupFormModalId.dirty || signupFormModalId.touched)">{{ 'texto_61' | translate }}
              </mdb-error>
              <mdb-success
                *ngIf="signupFormModalId.valid && (signupFormModalId.dirty || signupFormModalId.touched)">{{ 'texto_62' | translate }}
              </mdb-success>
            </div>
    
            <div class="md-form mb-3">
              <input type="text" id="form-email" class="form-control" [formControl]="signupFormModalEmail"
                     mdbInput mdbValidate>
              <label for="form-email">Email</label>
              <mdb-error *ngIf="signupFormModalEmail.invalid && (signupFormModalEmail.dirty || signupFormModalEmail.touched)">
                {{ 'texto_61' | translate }}
              </mdb-error>
              <mdb-success *ngIf="signupFormModalEmail.valid && (signupFormModalEmail.dirty || signupFormModalEmail.touched)">
                {{ 'texto_62' | translate }}
              </mdb-success>
            </div>

            <div class="md-form mb-3">
                <input type="text" id="form-name" class="form-control" [formControl]="signupFormModalName"
                       mdbInput mdbValidate>
                <label for="form-name">{{ 'texto_35' | translate }}</label>
                <mdb-error *ngIf="signupFormModalName.invalid && (signupFormModalName.dirty || signupFormModalName.touched)">
                  {{ 'texto_61' | translate }}
                </mdb-error>
                <mdb-success *ngIf="signupFormModalName.valid && (signupFormModalName.dirty || signupFormModalName.touched)">
                  {{ 'texto_62' | translate }}
                </mdb-success>
              </div>

              <div class="md-form mb-3">
                <input type="text" id="form-surname" class="form-control" [formControl]="signupFormModalSurname"
                       mdbInput mdbValidate>
                <label for="form-surname">{{ 'texto_36' | translate }}</label>
                <mdb-error *ngIf="signupFormModalSurname.invalid && (signupFormModalSurname.dirty || signupFormModalSurname.touched)">
                  {{ 'texto_61' | translate }}
                </mdb-error>
                <mdb-success *ngIf="signupFormModalSurname.valid && (signupFormModalSurname.dirty || signupFormModalSurname.touched)">
                  {{ 'texto_62' | translate }}
                </mdb-success>
              </div>
    
          </div>

        <div class="text-center mt-3">
          <button (click)="addUser()" mdbBtn  rounded="true" class="btn-primary mt-1 waves-light" mdbWavesEffect>{{ 'texto_60' | translate }}
          </button>
        </div>

    </div>
    <!--/.Content-->
  </div>
</div>